module.exports = __webpack_public_path__ + "img/calendar-check.2a9c1d1b.svg";